<template>
	<AiChat />
</template>

<script>
	import AiChat from './components/AiChat.vue'

	export default {
		name: 'App',
		components: {
			AiChat,
		}
	}
</script>

<style>
	body {
		padding: 0;
		margin: 0;
	}
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: inherit;
		min-height: 100vh;
		background-color: white;
		/* 关键属性 */
		display: flex;
		flex-direction: column;
		/* 适合内容垂直排列 */
	}
</style>